import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { testTrainingSchema } from "features/tests/create/components/_schemas";
import { IFormCreateTestSchool } from "features/tests/create/components/_interfaces";
import TestConfig from "features/tests/create/components/TestConfig";
import AddTestButton from "features/tests/create/components/AddTestButton";
import TestPageTitle from "features/tests/create/components/TestPageTitle";
import useCreateTest from "features/tests/create/hooks/useCreateTest";

const CreateTestSchool = () => {

    const methods = useForm<IFormCreateTestSchool>({
        resolver: yupResolver(testTrainingSchema),
    });

    const testForm = useCreateTest({
        type: "school",
        setError: methods.setError,
        clearErrors: methods.clearErrors,
    });

    const {
        createTestData,
        errorMessage,
        setErrorMessage,
        successMessage,
        isFormValid,
        submitTest,
    } = testForm;

    useEffect(() => {
        if (Object.keys(methods.formState.errors).length === 0) {
            setErrorMessage("");
        }
    }, [createTestData]);

    if(successMessage) {
        return (
            <>
                <TestPageTitle title="școlar" />
                <Typography>{successMessage}</Typography>
            </>
        );
    }

    return (
        <>
            <TestPageTitle title="școlar" />
            <Box width="100%">
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submitTest)} noValidate>
                        <Box mb={{xs: 5, md: 3}}>
                            <TestConfig
                                type="school"
                                subjects={testForm.subjects}
                                grades={testForm.grades}
                                createTestData={testForm.createTestData}
                                setClassroomHandler={testForm.setClassroomHandler}
                                setSelectedStudentsHandler={testForm.setSelectedStudentsHandler}
                                setSelectAllStudentsHandler={testForm.setSelectAllStudentsHandler}
                                handleSelectChange={testForm.handleSelectChange}
                                handleInputChange={testForm.handleInputChange}
                                setSubjectHandler={testForm.setSubjectHandler}
                                setGradeHandler={testForm.setGradeHandler}
                                setSelectedCategoriesHandler={testForm.setSelectedCategoriesHandler}
                                handleTestStartDate={testForm.handleTestStartDate}
                                loading={testForm.loading}
                                errors={methods.formState.errors}
                                tags={testForm.tags}
                                selectedCategoriesCount={testForm.selectedCategoriesCount}
                                setSelectedStandardsHandler={testForm.setSelectedStandardsHandler}
                            />
                        </Box>
                        {isFormValid && (
                            <AddTestButton errorMessage={errorMessage} />
                        )}
                    </form>
                </FormProvider>
            </Box>
        </>
    );
};

export default CreateTestSchool;
